module.exports = __webpack_public_path__ + "static/media/shoulder_l.c66382cc.png";